import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import axios from "axios";
import { Dimmer } from "../spinner";
import { validaSoloNumero } from "../../util/varios";

const ModalCoordenadas = (props) => {
  const op = require("../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    vertice: "",
    idInmueble: "",
    norte: "",
    este: "",
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validarCampos = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        buscarInmueble(event.target.value.replace(/\./g, ""));
      }
    }
  };
  const eliminarCoordenadas = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/catastro/eliminarCoordenadas/${body.vertice}`;
      const response = await axios.delete(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Coordenadas Eliminadas Correctamente",
        icono: "exito",
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar el inmueble",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const guardarCoordenadas = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/catastro/registrarCoordenadas`;
      const response = await axios.post(
        endpoint,
        {
          idInmueble: body.idInmueble,
          norte: body.norte,
          este: body.este,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "Coordenadas Registradas Correctamente",
          icono: "exito",
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar el inmueble",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const salir = () => {
    props.onHide();
    props.buscarCoordenadas();
    blanquear();
  };
  const blanquear = () => {
    setLoading(false);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      idInmueble: "",
      norte: "",
      este: "",
    });
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.521)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        if (props.operacion === 3 && props.coordenadas) {
          setBody((prev) => ({
            ...props.coordenadas,
            idInmueble: props.idInmueble,
          }));
        } else {
          setBody((prev) => ({
            ...prev,
            idInmueble: props.idInmueble,
          }));
        }

        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          {operacion === 1 ? "Registrar Coordenadas" : "Eliminar Coordenadas"}
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between col-md-12">
          <div className="col-md-6 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Norte:
              </span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="norte"
                onKeyUp={validarCampos}
                onChange={onChange}
                value={body.norte}
                disabled={operacion === 3}
              />
            </div>
          </div>
          <div className="col-md-6 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Este:
              </span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="este"
                onKeyUp={validarCampos}
                onChange={onChange}
                value={body.este}
                disabled={operacion === 3}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() =>
            operacion === 1 ? guardarCoordenadas() : eliminarCoordenadas()
          }
          className="btn-sm rounded-pill btn btn-success col-md-2"
        >
          <i className="fas fa-check"></i> Aceptar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.icono === "exito"
            ? salir()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};

export default ModalCoordenadas;
